var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "box"
    },
    [
      _vm.result === "fail"
        ? _c("div", { staticClass: "result-box" }, [
            _c("img", {
              staticClass: "img2",
              attrs: { src: require("../../assets/002.png"), alt: "" }
            }),
            _c("p", [_vm._v(_vm._s(_vm.errorMessage))])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }